import React from 'react';

export const Loader = ({ text = 'Loading', show = true }) => {
  if (!show) return null;
  return (
    <div className="cosmic-loader-overlay">
      <div className="cosmic-orb">
        <div className="ring ring-3" />
        <div className="ring ring-2" />
        <div className="ring ring-1" />
        <div className="particle" style={{ animationDelay: '0s' }} />
        <div className="particle" style={{ animationDelay: '-1s' }} />
        <div className="particle" style={{ animationDelay: '-2s' }} />
        <div className="core" />
      </div>
      <div className="cosmic-text">{text}</div>
    </div>
  );
};

export const InlineLoader = ({ text = 'Loading...' }) => (
  <div className="flex flex-center" style={{ padding: '48px 20px', color: 'var(--text-secondary)' }}>
    <span className="btn-spinner" style={{ borderTopColor: 'var(--neon-cyan)' }} />
    {text}
  </div>
);

export const ButtonSpinner = () => <span className="btn-spinner" />;
